import { Box, Chip } from '@mui/material'
import { FC } from 'react'
import { Task } from 'types'
import { GridRenderCellParams, GridTreeNodeWithRender } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

interface TypeCellProps {
  params: GridRenderCellParams<Task, any, any, GridTreeNodeWithRender>
}

const TypeCell: FC<TypeCellProps> = ({ params }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Chip
        label={params?.value}
        sx={{
          backgroundColor: 'transparent',
          textAlign: 'left',
          color: renderColorByString(params?.value),
          fontWeight: 'bold',
          width: '100%',
          height: '100%',
          borderRadius: '4px',
        }}
      />
    </Box>
  )
}
export default TypeCell
